import * as React from "react";
import { PriceBox, CurrentPrice, OriginPrice } from "./styled";
export var PriceUIType;
(function (PriceUIType) {
    PriceUIType[PriceUIType["Small"] = 0] = "Small";
    PriceUIType[PriceUIType["Middle"] = 1] = "Middle";
    PriceUIType[PriceUIType["Large"] = 2] = "Large";
})(PriceUIType || (PriceUIType = {}));
export const PriceView = (props) => {
    const { price, originPrice, type = PriceUIType.Middle } = props;
    return (React.createElement(PriceBox, { type: type },
        React.createElement(CurrentPrice, { className: "current" }, price),
        price !== originPrice && React.createElement(OriginPrice, { className: "origin" }, originPrice)));
};
